(() => {
  'use strict';
  const mobile = window.matchMedia('(max-width: 767px)');
  let dispose = null;

  function start() {
    if (dispose) { dispose(); dispose = null; }
    if (!mobile.matches) return;

    const events = new AbortController();
    const options = { signal: events.signal };
    let host, activator, edge, stateObserver, toolbarObserver;
    let discoverTimer, idleTimer, attempts = 0, open = false, revealed = false;
    let addedHostId = false;

    function currentActivator() {
      const root = host?.shadowRoot;
      return root?.querySelector('shopify-agent-runtime')?.shadowRoot?.querySelector('button[part~="activator"]') || root?.querySelector('button[part~="activator"]');
    }

    function setRevealed(value) {
      activator = currentActivator() || activator;
      revealed = value;
      host.toggleAttribute('data-rhl-chat-revealed', value);
      edge.setAttribute('aria-expanded', String(value));
      edge.setAttribute('aria-label', value ? 'Hide chat button' : 'Show chat button');
      clearTimeout(idleTimer);
      if (value && !open) idleTimer = setTimeout(() => {
        if (!open && !edge.matches(':focus-visible') && !activator.matches(':focus-visible')) setRevealed(false);
      }, 7000);
    }

    function syncOpen() {
      const wasOpen = open;
      open = host.hasAttribute('open');
      host.toggleAttribute('data-rhl-chat-open', open);
      edge.hidden = open;
      if (open || wasOpen) setRevealed(false);
    }

    function position() {
      const toolbar = document.querySelector('.hdt-toolbar');
      const rect = toolbar?.getBoundingClientRect();
      const visible = toolbar && getComputedStyle(toolbar).display !== 'none' && rect.height > 0 && rect.top < window.innerHeight;
      const clearance = (visible ? Math.ceil(rect.height) : 0) + 16;
      host.style.setProperty('--rhl-chat-bottom', `${clearance}px`);
      edge.style.setProperty('--rhl-chat-bottom', `${clearance}px`);
    }

    function bind() {
      host = document.querySelector('shopify-chat');
      activator = currentActivator();
      if (!activator) return false;

      edge = document.createElement('button');
      edge.type = 'button';
      edge.className = 'rhl-chat-edge';
      if (!host.id) { host.id = 'rhl-mobile-inbox'; addedHostId = true; }
      edge.setAttribute('aria-controls', host.id);
      edge.innerHTML = '<span class="rhl-chat-edge__tab"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="m14 6-6 6 6 6"/></svg></span>';
      document.body.append(edge);
      position();
      setRevealed(false);
      syncOpen();
      host.setAttribute('data-rhl-chat-ready', '');

      edge.addEventListener('click', event => {
        setRevealed(!revealed);
        if (revealed && event.detail === 0) activator.focus({ preventScroll: true });
      }, options);
      document.addEventListener('pointerdown', event => {
        if (!open && revealed && !event.composedPath().includes(host) && !edge.contains(event.target)) setRevealed(false);
      }, options);
      document.addEventListener('keydown', event => {
        if (event.key === 'Escape' && !open && revealed) {
          setRevealed(false);
          edge.focus({ preventScroll: true });
        }
      }, options);
      stateObserver = new MutationObserver(syncOpen);
      // Inbox replaces its internal button on render; the host's open attribute is stable.
      stateObserver.observe(host, { attributes: true, attributeFilter: ['open'] });
      const toolbar = document.querySelector('.hdt-toolbar');
      if (toolbar && 'ResizeObserver' in window) {
        toolbarObserver = new ResizeObserver(position);
        toolbarObserver.observe(toolbar);
      }
      window.addEventListener('resize', position, options);
      clearInterval(discoverTimer);
      discovery.disconnect();
      return true;
    }

    // Inbox hydrates asynchronously. Leave its native launcher intact if unavailable.
    const discovery = new MutationObserver(() => { if (!edge) bind(); });
    discovery.observe(document.body, { childList: true });
    if (!bind()) discoverTimer = setInterval(() => {
      if (bind() || ++attempts >= 120) clearInterval(discoverTimer);
    }, 500);

    dispose = () => {
      events.abort();
      clearInterval(discoverTimer);
      clearTimeout(idleTimer);
      discovery.disconnect();
      stateObserver?.disconnect();
      toolbarObserver?.disconnect();
      edge?.remove();
      if (host) {
        ['data-rhl-chat-ready', 'data-rhl-chat-revealed', 'data-rhl-chat-open'].forEach(name => host.removeAttribute(name));
        host.style.removeProperty('--rhl-chat-bottom');
        if (addedHostId) host.removeAttribute('id');
      }
    };
  }
  mobile.addEventListener('change', start);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
